import { Highlighter, listItemSectionBuilder, listItemSelectBuilder } from '@wix/design-system';
import { DomainsApiClient } from '@wix/domains-serverless-interface/react-kit';
import React, { useMemo, useState } from 'react';
import { CoreDomainSearchModule } from '../module';
import { parseDomain } from '@wix/domains-serverless-interface';
export const useUnassignedDomainsList = (predicate, disabled) => {
  const enabled = !disabled;
  const {
    data
  } = DomainsApiClient.hooks.useDomainsAccount({}, enabled);
  const query = CoreDomainSearchModule.SDK.domainInputStore.useQuery();
  const {
    t
  } = CoreDomainSearchModule.internals.useTranslations();
  const [isOpen, setIsOpen] = useState(false);
  const titleItems = useMemo(() => !query && enabled ? [listItemSectionBuilder({
    id: 0,
    type: 'title',
    title: t('core_domain_search.domain_gate.search_bar.domain_drop_down.header')
  })] : [], [enabled, query, t]);
  const unassingedDomainsOptions = useMemo(() => {
    var _data$unassignedDomai;
    return enabled && data != null && (_data$unassignedDomai = data.unassignedDomains) != null && _data$unassignedDomai.length ? [...titleItems, ...(data == null ? void 0 : data.unassignedDomains.map(domain => {
      const parsedDomain = parseDomain(domain);
      return listItemSelectBuilder({
        id: parsedDomain.formattedInput,
        title: /*#__PURE__*/React.createElement(Highlighter, {
          match: query
        }, parsedDomain.formattedInput),
        size: 'small'
      });
    }).filter(option => predicate == null ? void 0 : predicate(option.id)))] : [];
  }, [data == null ? void 0 : data.unassignedDomains, enabled, predicate, query, titleItems]);
  return {
    unassingedDomainsOptions,
    setIsOpen,
    isOpen
  };
};
//# sourceMappingURL=useUnassignedDomainsList.js.map